import {
  Box,
  Flex,
  Image,
  Input,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import trashIcon from "../../assets/images/projectManagement/trash-2.svg";
import { useCallback } from "react";

export const FormBonusEmployee = ({
  filteredOptions,
  selectedMain,
  deleteData,
  onChangeName,
  isFocused,
  onFocus,
  onBlur,
  required,
  searchTermCustomerType,
  setSearchTermCustomerType,
}) => {
  const [dataSelect, setDataSelect] = useState();
  // const [searchTerm, setSearchTerm] = useState("");
  // const [dataBonus, setDataBonus] = useState("");
  // const [dataJobTitle, setDataJobTitle] = useState("");

  const onChangeActionName = useCallback(
    (value) => {
      onChangeName(value);
    },
    [onChangeName]
  );

  useEffect(() => {
    if (
      selectedMain !== undefined &&
      selectedMain !== null &&
      selectedMain !== ""
    ) {
      setDataSelect(selectedMain);
    }
  }, [selectedMain]);

  const check = filteredOptions.find((option) => option.value === (dataSelect?.value || dataSelect));

  // const filteredResults = useMemo(() => {
  //   return filteredOptions.filter((option) =>
  //     option.label.toLowerCase().includes(searchTerm.toLowerCase())
  //   );
  // }, [filteredOptions, searchTerm]);

  return (
    <Flex
      justifyContent={"space-between"}
      alignItems={"flex-start"}
      gap={"27px"}
      mb={"16px"}
      w={"100%"}
    >
      <Box
        w={"100%"}
        borderRadius={"12px"}
        maxW={"100%"}
        display={"flex"}
        flexDirection={"column"}
        gap={"8px"}
        h={"auto"}
        zIndex={isFocused ? 4 : 1}
      >
        <Flex gap={"4px"} alignItems={"center"}>
          <Text
            fontSize={{ base: "12px" }}
            fontWeight={400}
            lineHeight={"15px"}
            color={"var(--color-label-employee)"}
          >
            Tên nhân viên
          </Text>
          {required && (
            <Text fontSize={{ base: "12px" }} color={"red"} lineHeight={"15px"}>
              *
            </Text>
          )}
        </Flex>

        <Menu matchWidth>
          <Flex gap={"8px"}>
            <MenuButton
              _active={{
                border: "1px solid var(--color-option-employee-hover)",
                borderBottom: "1px solid var(--color-option-employee-hover)",
              }}
              _hover={{
                boxShadow: "none",
              }}
              type={"button"}
              // rightIcon={<ChevronDownIcon color="#000" />}
              w="100%"
              backgroundColor="#FFF"
              border={"1px solid var(--bg-line-employee)"}
              fontSize="14px"
              fontWeight={500}
              whiteSpace="nowrap"
              overflow="hidden"
              textOverflow="ellipsis"
              textAlign={"left"}
              p={"0"}
              h={"auto"}
              maxH={"44px"}
              padding={"13px 12px 14px 12px"}
              color={
                dataSelect !== undefined &&
                dataSelect !== null &&
                dataSelect !== ""
                  ? "var(--color-info-employee)"
                  : "var(--color-placeHolder-employee)"
              }
              borderRadius={"8px"}
              borderBottom={"1px solid var(--bg-line-employee)"}
              onFocus={onFocus}
              onBlur={onBlur}
            >
              {dataSelect !== undefined &&
              dataSelect !== null &&
              dataSelect !== "" &&
              check
                ? check.label
                : dataSelect?.fullName || "Tên nhân viên dự án"}
            </MenuButton>
            <Image
              cursor={"pointer"}
              src={trashIcon}
              mr={"12px"}
              mt={"12px"}
              w={"22px"}
              h={"22px"}
              minH={"22px"}
              minW={"22px"}
              onClick={deleteData}
              _hover={{
                filter: "var(--filter-red)",
              }}
            />
          </Flex>

          <MenuList
            borderRadius="12px"
            minW="275px"
            overflow={"scroll"}
            maxH={"250px"}
            zIndex={4}
          >
            <Input
              placeholder="Tìm kiếm..."
              value={searchTermCustomerType}
              onChange={(e) => setSearchTermCustomerType(e.target.value)}
              mb="8px"
              p="8px"
              border="1px solid var(--bg-line-employee)"
              borderRadius="8px"
              width="90%"
              mx="auto"
              display="block"
            />
            {filteredOptions.length > 0 ? (
              filteredOptions.map((option) => (
                <MenuItem
                  key={option.value}
                  onClick={() => onChangeActionName(option)}
                  backgroundColor={"#FFF"}
                  color={"#000"}
                >
                  {option.label}
                </MenuItem>
              ))
            ) : (
              <Box fontSize="14px" p="12px" textAlign="center">
                Không tìm thấy kết quả
              </Box>
            )}
          </MenuList>
        </Menu>
      </Box>
    </Flex>
  );
};
